module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "special-tabs"
  }, _vm._l((_vm.tabList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "tabs-item",
      class: _vm.activeName === item.name ? 'tabs-item-active' : '',
      on: {
        "click": function($event) {
          return _vm.onTabClick(index, item)
        }
      }
    }, [_vm._v("\n      " + _vm._s(item.name) + "\n    ")])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d6c8258","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mainindex/SpecialTabs.vue
// module id = 1445
// module chunks = 0